import {Component, Inject, Input, OnDestroy, OnInit} from "@angular/core";
import {HttpParams} from "@angular/common/http";
import {TableControllerService} from "../../../services/table-controller.service";
import {ActivatedRoute, Router} from "@angular/router";
import {BehaviorSubject, filter, firstValueFrom, forkJoin, Observable, Subject, Subscription, takeUntil} from "rxjs";
import {map, tap} from "rxjs/operators";
import {GeneralService} from "../../../services/crud/general.service";
import {FilterControllerService} from "../../../services/filter-controller.service";
import * as saveAs from "file-saver";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {DialogComponent} from "libComm";

import {
	getTextWidth,
	hasSubArray,
	refactorName,
	replacer,
	reviver,
	transformIdToValueFromList
} from "../../../utils/generic";
import {Data, DataSet, Layout, SectionLayout} from "../../../models/layout";
import {LayoutServiceService} from "../../../services/layout.service";
import {ALERT_TYPE} from "../alert/alert.enumerate";
import {AlertService} from "../alert/alert.service";
import {DndComponent} from "../dnd/dnd.component";
import {FILTER_TYPE, FilterInterface} from "libComm";
import {IMultiSelectOption} from "libComm";
import {cloneDeep, first} from "lodash";
import {TranslateService} from "@ngx-translate/core";
import {SaveConfirmComponent} from "libComm";
import {PageEventType} from 'libComm';
import { CustomActionsService } from "../custom-actions/custom-actions.service";
import { ActionEvent } from "../data-table/models/data-table.models";
import {SpinnerService} from "../../../services/spinner.service";

@Component({
	selector: "detail-data-table",
	templateUrl: "./detail-data-table.component.html",
	styleUrls: ["./detail-data-table.component.scss"],
	host: {'class': 'h-100'},
	providers: [TableControllerService, FilterControllerService]
})
export class DetailDataTableComponent implements OnDestroy, OnInit
{
	private searchSubscription?: Subscription;

	private _interactionCycle: Subject<void> = new Subject<void>();
	private _pageCycle: Subject<void> = new Subject<void>();

	@Input()
	apiUrl: string = "";
	@Input()
	apiParent: string = "";
	@Input()
	titlePage: string = "";
	@Input()
	pageId: string = "";
	@Input()
	id: string = "";
	@Input() tableContainerClass: string = '';

	@Input()
	isInner: boolean = false;

	@Input() mainGridReloadData?: () => void;

	isLoading: boolean = false;

	// ITOEM-35 [MB 07/04/2025]: this component in used for both  LYO_SECTABLE (usually used inside the main page handled by general component)
	// and LYO_DETAIL_SECTABLE (usually used inside detail-page.component)
	secTableIdentifier: string[] = ["LYO_SECTABLE", "LYO_DETAIL_SECTABLE"];

	constructor(
		public tableController: TableControllerService,
		public filterController: FilterControllerService,
		private route: ActivatedRoute,
		private generalDataService: GeneralService,
		public dialog: MatDialog,
		public layoutService: LayoutServiceService,
		public alertService: AlertService,
		private translateService: TranslateService,
		private customActionsService: CustomActionsService,
		private spinner: SpinnerService,
		// retrieve dialog input values
		@Inject(MAT_DIALOG_DATA) public data: any
	)
	{

		this.tableController.onPaginationChange.subscribe((event) =>
		{
			this.savedPaginator = event;
			const isReset = event.isReset === true || event.pageIndex === 0;
			this.onSearch(event.pageIndex, event.loader, this.sortedColumns, this.savedFilter, this.dts, isReset);
		});

		this.tableController.onSortChange.subscribe((event) =>
		{
			this.sortedColumns = event.sorting;
			sessionStorage.setItem("sort_" + this.pageId, JSON.stringify(event.sorting, replacer));
			this.onSearch(0, this.tableController.dataSet.length, event.sorting, this.savedFilter, this.dts, true);
		});

		tableController.customizeAfterAddClick = (newRowObj: any): any =>
		{
			//newRowObj[newRowObj.obackupDTO]=null
			delete newRowObj.lDocuments;
			delete newRowObj.backup;
			return newRowObj
		}
		// set to null and return constructor otherwise delete, + problem detail component
		// for now
	}

	ngOnDestroy(): void
	{
		if (!!this.searchSubscription)
		{
			this.searchSubscription.unsubscribe();
		}
		console.log('destroying page');
		this._pageCycle.next();
	}

	ngOnInit(): void
	{
		this.getQueryParam();
		console.log('building page')
	}

	layout: Layout | undefined;

	savedFilter: any = [];

	savedParams: HttpParams = new HttpParams();

	savedPaginator: PageEventType = {
		pageIndex: 0,
		previousPageIndex: 0,
		loader: 50,
		size: 0
	};

	sortedColumns: Map<string, { order: number; type: "asc" | "desc" }> = new Map();

	disabledColumns: string[] = ["INSERT_USER", "INSERT_DATE", "UPDATE_USER", "UPDATE_DATE"];

	dts: string = "";

	ats: string = "";

	checkStringOrNumberValidity = (value: any | null) =>
	{
		return value !== undefined && value !== null
	}

	trackBySectionId(index: number, sectionLayout: SectionLayout): string
	{
		return sectionLayout.id;
	}

	refreshData(
		srtdClmns: Map<
			string,
			{
				order: number;
				type: "asc" | "desc";
			}
		>                        = new Map(),
		newFilter: Array<string> = new Array<string>()
	)
	{
		this.onSearch(0, this.savedPaginator.loader, srtdClmns, newFilter, this.dts, true);
	}

	getQueryParam()
	{
		this.route.queryParams.pipe(
			takeUntil(this._interactionCycle),
			map((params) =>
			{
				const sorted = sessionStorage.getItem("sort_" + this.pageId);
				if (sorted)
				{
					this.tableController.sortedColumns = JSON.parse(sorted, reviver);
				}
				else
				{
					this.tableController.sortedColumns = new Map<string, { order: number; type: "asc" | "desc" }>();
				}

				const flt = localStorage.getItem("FLT_" + this.pageId);
				if (flt)
				{
					this.filterController.filterModels = JSON.parse(flt, reviver)
					this.onFilterClick(null, false);
				}

				this.getPageLayout(this.pageId);

				return params;
			})
		).subscribe({
			next: (params) =>
			{
			},
			error: (err) =>
			{
				//(err)
				this.alertService.add({
					type: ALERT_TYPE.DANGER,
					message: "Some error occurred on layout retrive",
					timeout: 5000,
					selfClose: null
				});
			}
		});
	}

	onFilterClick(event: any, isSearching: boolean = true)
	{
		const newFilter: any = [];

		localStorage.setItem("FLT_" + this.pageId, JSON.stringify(this.filterController.filterModels, replacer));
		const _filterList = this.filterController.filterModels.filter((model) => !model.isHide);

		_filterList.forEach((filter) =>
		{
			console.log(filter)
			if (filter.filterSelectedOption.haveSecondParam && filter.filterSelectedOption.id == "_-d_")
			{
				if (this.checkStringOrNumberValidity(filter.firstValue)) newFilter.push(filter.columnName + "_>d_" + filter.firstValue);
				if (this.checkStringOrNumberValidity(filter.secondValue)) newFilter.push(filter.columnName + "_<d_" + filter.secondValue);
			}
			else
				if (filter.filterSelectedOption.haveSecondParam && filter.filterSelectedOption.id == "_-_")
				{
					if (this.checkStringOrNumberValidity(filter.firstValue)) newFilter.push(filter.columnName + "_>_" + filter.firstValue);
					if (this.checkStringOrNumberValidity(filter.secondValue)) newFilter.push(filter.columnName + "_<_" + filter.secondValue);
				}
				else
				{
					if (filter.filterSelectedOption.haveFirstParam)
					{
						if (this.checkStringOrNumberValidity(filter.firstValue) && filter.firstValue.length > 0)
						{
							if (filter.filterType == FILTER_TYPE.MULTI_SELECTION)
							{
								newFilter.push(filter.columnName + filter.filterSelectedOption.id + filter.firstValue.join("§"));
							}
							else
							{
								newFilter.push(filter.columnName + filter.filterSelectedOption.id + filter.firstValue);
							}
						}
					}
					else
					{
						filter.firstValue = []
						newFilter.push(filter.columnName + filter.filterSelectedOption.id + "#");
					}
				}
		});
		this.savedFilter = newFilter;
		this.filterController.refreshViewedFilter();

		if (isSearching)
		{
			this.tableController.dataSet = [];
			this.onSearch(0, this.savedPaginator.loader, this.sortedColumns, newFilter);
		}

	}

	onCancelClick()
	{
		this.tableController.deletedRows = [];
		this.tableController.selection.clear();
		this.tableController.dataSet = [];
		this.onSearch(0, this.savedPaginator.loader, this.sortedColumns, this.savedFilter);
	}


	refresh()
	{
		this.onSearch(0, this.savedPaginator.loader, this.sortedColumns, this.savedFilter, this.dts, true);
	}

	onSearch(
		page: number,
		size: number,
		sorting: Map<string, { order: number; type: "asc" | "desc" }>,
		filters: Array<string>,
		dts: string      = this.dts,
		refresh: boolean = false,
		extraParameters: Map<string, string | number | boolean> = new Map()
	)
	{
		this.isLoading = true;
		let params = new HttpParams().set("page", page).set("size", size).set("dts", dts);

		new Map([...sorting.entries()].sort((a, b) => a[1].order - b[1].order)).forEach((value, key, map) =>
		{
			if (!!!params.get("sort")) params = params.set("sort", refactorName(key) + (value.type == "desc" ? ",desc" : ""));
			else params = params.append("sort", refactorName(key) + (value.type == "desc" ? ",desc" : ""));
		});
		filters.forEach((filter) =>
		{
			if (!filter.includes("&"))
			{
				if (!!!params.get("search")) params = params.set("search", filter);
				else params = params.append("search", filter);
			}
			else
			{
				filter.split("&").forEach((value) =>
				{
					if (!!!params.get("search")) params = params.set("search", value);
					else params = params.append("search", value);
				});
			}
		});
		params = params.append("id", this.id);

		// ITOEM-18 added custom parameters if present
		extraParameters.forEach((value, key) =>
		{
			params = params.set(key, value.toString());
		});

		this.savedParams = params;

		// //this.spinner.showWithTitle("data", this.translateService.instant('LOADING_RESULTSET'));
		this.searchSubscription = this.generalDataService.getData(this.apiParent + "/" + this.apiUrl, undefined, params).pipe(
			takeUntil(this._interactionCycle)
		).subscribe({
			next: (res) =>
			{
				if (refresh)
				{
					this.tableController.dataSet = res["oContent"]["rs"]["content"];
					if (!!this.layout) this.catchAllSelectedOptions(this.layout);
				}
				else
				{
					this.tableController.dataSet = !!this.tableController.dataSet
						? hasSubArray(this.tableController.dataSet, res["oContent"]["rs"]["content"])
						: res["oContent"]["content"]["rs"];

				}

				this.tableController.numElementsLoaded = this.tableController.dataSet.length;
				this.tableController.numElementsSize = res["oContent"]["rs"].totalElements;

				this.filterController._filterValues.next(res["oContent"]["fv"]);
				this.tableController._filterValues.next(res["oContent"]["tv"]);
				this.calculateSizeComplete();
				this.isLoading = false;
			},
			error: (error) =>
			{
				this.isLoading = false;
			}
		});
	}

	/**
	 * This method handle all events from the grid base on it's event name
	 *
	 * @param event
	 * @returns
	 */
	actionCatcher(event: ActionEvent)
	{
		const { action, rowIndex, row } = event;

		if (action.endsWith("_ALL"))
		{
			if (action.startsWith("ACT_IMPORT"))
			{
				this.importAll();
			}
			else
				if (action.startsWith("ACT_EXPORT"))
				{
					this.exportAll();
				}
				else
					if (action.startsWith("ACT_SAVE"))
					{ //Save all
						this.saveAll(this.id);
					}
		}
		else
			if (action.endsWith("_ID"))
			{
				if (action.startsWith("ACT_DELETE"))
				{
					this.deleteRow();
				}

				// LZ: event triggered when a user modified some data in any page, and he/she is trying to save modification
				if (action.startsWith("ACT_SAVE"))
				{
					this.saveRow(this.id);
				}
			}
			else
			{

				if (action.startsWith("ACT_EXPORT"))
				{
					this.exportSelected();
				}

				if (action.startsWith("ACT_DELETE"))
				{
					this.deleteMultipleRow();
				}

				this.customActionsService.handleCustomAction(action, {
					reloadData: this.reloadData,
					reloadMainData: this.mainGridReloadData,
					row,
					rowIndex,
					tableController: this.tableController,
					spinner: this.spinner,
					apiUrl: this.apiUrl,
					apiParent: this.apiParent,
					titlePage: this.titlePage,
					savedParams: this.savedParams,
					layout: this.layout,
					pageId: this.pageId,
					actionsets: this.layout.sectionLayouts.find((sectionLayout) => sectionLayout.id == "LYO_SECTABLE")?.actionset[0]


				});
			}
	}

	deleteOneRow()
	{
		const dialogRef = this.dialog.open(DialogComponent, {
			data: {
				title: this.translateService.instant("LABEL_DELETION_TITLE"),
				content: this.translateService.instant("LABEL_CONFIRM"),
				cancelButtonLabel: this.translateService.instant("ACT_NO"),
				cancelButtonColor: "basic",
				confirmButtonLabel: this.translateService.instant("ACT_YES"),
				confirmButtonColor: "warn"
			}
		});

		dialogRef.afterClosed().subscribe((res) =>
		{
			if (!!res)
			{
				this.generalDataService.deleteData(this.apiParent + "/" + this.apiUrl, this.tableController.deletedRows, "d", new HttpParams().set("id", this.id)).pipe(takeUntil(this._interactionCycle)).subscribe((res) =>
				{
					this.tableController.deletedRows = [];

					this.onCancelClick();
				});
			}
		});
	}

	private catchAllSelectedOptions(layout?: Layout)
	{
		layout?.sectionLayouts.map((sectionLayout: SectionLayout) =>
		{
			sectionLayout.dataset.map((dataset: DataSet) =>
			{
				dataset.datas?.map((data: Data) =>
				{
					if (
						data.valuesFrom.includes("table") &&
						data.valuesFrom.includes("search_key") &&
						data.valuesFrom.includes("return_value") &&
						!data.isResultsetLinked
					)
					{
						this.generalDataService.getSelectionOption(this.replaceFilterValues(data.valuesFrom)).then((res) =>
						{
							data.optionValues = res;
						});
					}
					else
						if (data.type == "DTY_STATUS")
						{
							// ITOEM-5: added status filter
							// status filter value are structured as follow: ERROR-ERROR-error-F44336;WARNING-WARNING-warning-FFEB3B; INFO-INFO-info-4CAF50
							const list = data.fixListValues.split(";");
							data.optionValues = list.map(
								(options) =>
								{
									const optionList = options?.split("-") || [];
									return {
										id: optionList[0] || options,
										name: optionList[1] || options,
										matIcon: optionList[2] || "help",
										color: optionList[3] || "000"
									} as IMultiSelectOption;
								}
							);
						}
						else
						{
							if (data.fixListValues)
							{
								const list = data.fixListValues.split(";");
								data.optionValues = list.map(
									(option) =>
										({
											id: option,
											name: option
										} as IMultiSelectOption)
								);
							}
						}
				});

				dataset.filterset?.map((filter: FilterInterface) =>
				{
					if (filter.filterType == FILTER_TYPE.MULTI_SELECTION || filter.filterType == FILTER_TYPE.SELECTION)
					{
						if (filter.filterValues)
						{
							if (
								filter.filterValueSearch.includes("table") &&
								filter.filterValueSearch.includes("search_key") &&
								filter.filterValueSearch.includes("return_value") &&
								!filter.isResultsetLinked
							)
							{
								this.generalDataService.getSelectionOption(this.replaceFilterValues(filter.filterValueSearch)).then((res) =>
								{
									filter.filterValues = res;
								});
							}
							else
							{
								const list = filter.filterValueSearch.split(";");
								filter.filterValues = list.map(
									(option) =>
										({
											id: option,
											name: option
										} as IMultiSelectOption)
								);
							}
						}
					}
					else
						if (filter.filterType == FILTER_TYPE.STATUS)
						{
							// ITOEM-5: added status filter
							// status filter value are structured as follow: ERROR-ERROR-error-F44336;WARNING-WARNING-warning-FFEB3B; INFO-INFO-info-4CAF50
							const list = filter.filterValueSearch.split(";");
							filter.filterValues = list.map(
								(options) =>
								{
									const optionList = options?.split("-") || [];

									return {
										id: optionList[0] || options,
										name: optionList[1] || options,
										matIcon: optionList[2] || "help",
										color: optionList[3] || "000"
									} as IMultiSelectOption;
								}
							);
						}
					return filter;

				});
			});
		});
	}

	private getPageLayout(pageId: string)
	{
		this.isLoading = true;
		const newFilter: any = [];
		this.layoutService.getPageLayout(pageId).pipe(
			map((res) =>
			{
				this.layout = res?.layouts[0] ?? undefined;

				const tableSection = first(
					this.layout?.sectionLayouts.filter((section) => this.secTableIdentifier.includes(section.id)) ?? ([] as SectionLayout[])
				);

				this.dts = tableSection?.dataset[0]?.id ?? "";
				this.ats = tableSection?.actionset[0]?.id ?? "";
				this.tableController.setDatasets(tableSection?.dataset[0] ?? null);


				const filterSettings = sessionStorage.getItem("filter");
				if (!!filterSettings)
				{
					const filters = JSON.parse(filterSettings);
					if (!!filters[this.pageId] && !!filters[this.pageId].instance)
					{

						let oldFilters: FilterInterface[] = [];
						const flt = localStorage.getItem("FLT_" + this.pageId);
						if (flt)
						{
							oldFilters = JSON.parse(flt, replacer)
						}
						else
						{
							oldFilters = cloneDeep(filters[this.pageId].instance);
						}


						const newFilters = cloneDeep(
							this.layout?.sectionLayouts?.filter((sectionLayout) => sectionLayout.id == "LYO_SECFILT").flatMap((section) => section.dataset).flatMap((datasets) => datasets.filterset).filter((flts) => flts != null)
						) as FilterInterface[];
						/*const newFilters = cloneDeep(this.layout?.sectionLayouts.filter((sectionLayout) => sectionLayout.id == "LYO_SECFILT").pop()
						  ?.dataset[0]?.filterset ?? [])*/
						this.filterController.filterModels = newFilters.map((fltInt) =>
						{
							for (let f of oldFilters)
							{
								const flt = cloneDeep(f);
								if (fltInt.filterId == flt.filterId)
								{
									fltInt.firstValue = flt.firstValue;
									fltInt.filterType = flt.filterType;
									fltInt.lFilterOptions = flt.lFilterOptions;
									fltInt.columnLabel = flt.columnLabel;
									fltInt.columnName = flt.columnName;
									fltInt.filterValues = flt.filterValues;
									fltInt.filterValueSearch = flt.filterValueSearch;
									fltInt.selectedOption = flt.selectedOption;
									fltInt.filterSelectedOption = flt.filterSelectedOption;
								}
							}
							return fltInt;
						});
					}
					else
					{
						this.filterController.filterModels =
							this.layout?.sectionLayouts.filter((sectionLayout) => sectionLayout.id == "LYO_SECFILT").pop()?.dataset[0]?.filterset ?? [];
					}
					this.filterController.refreshViewedFilter();
				}
				else
				{
					this.filterController.filterModels =
						this.layout?.sectionLayouts.filter((sectionLayout) => sectionLayout.id == "LYO_SECFILT").pop()?.dataset[0]?.filterset ?? [];
					this.filterController.refreshViewedFilter();
				}

				const filterString = localStorage.getItem("FLT_" + this.pageId);
				if (!!filterString)
				{
					const _filterList: FilterInterface[] = JSON.parse(filterString, replacer);

					if (_filterList.length > 0)
					{
						this.filterController.filterModels = this.filterController.filterModels.map((flt) =>
						{
							if (_filterList.some((filter) => filter.columnName == flt.columnName))
							{
								return _filterList.filter((f) => (f.columnName == flt.columnName))[0];
							}
							return flt;
						});
					}

					this.filterController.filterModels.filter((model) => !model.isHide).forEach((filter) =>
					{
						//(filter)
						if (filter.filterSelectedOption.haveSecondParam && filter.filterSelectedOption.id == "_-d_")
						{
							if (this.checkStringOrNumberValidity(filter.firstValue)) newFilter.push(filter.columnName + "_>d_" + filter.firstValue);
							if (this.checkStringOrNumberValidity(filter.secondValue)) newFilter.push(filter.columnName + "_<d_" + filter.secondValue);
						}
						else
							if (filter.filterSelectedOption.haveSecondParam && filter.filterSelectedOption.id == "_-_")
							{
								if (this.checkStringOrNumberValidity(filter.firstValue)) newFilter.push(filter.columnName + "_>_" + filter.firstValue);
								if (this.checkStringOrNumberValidity(filter.secondValue)) newFilter.push(filter.columnName + "_<_" + filter.secondValue);
							}
							else
							{
								if (filter.filterSelectedOption.haveFirstParam)
								{
									if (this.checkStringOrNumberValidity(filter.firstValue) && filter.firstValue.length > 0)
									{
										if (filter.filterType == FILTER_TYPE.MULTI_SELECTION)
										{
											newFilter.push(
												filter.columnName + filter.filterSelectedOption.id + filter.firstValue.join("§")
											);
										}
										else
										{
											newFilter.push(filter.columnName + filter.filterSelectedOption.id + filter.firstValue);
										}
									}
								}
								else
								{
									newFilter.push(filter.columnName + filter.filterSelectedOption.id + "#");
								}
							}
					});
					this.filterController.refreshViewedFilter();
				}

				const layoutsString = localStorage.getItem("layout");

				const sorted = sessionStorage.getItem("sort_" + this.pageId);
				if (sorted)
				{
					this.tableController.sortedColumns = JSON.parse(sorted, reviver);
				}
				else
				{
					const dtArray: Data[] = Array.from(
						new Set(
							(res?.layouts ?? ([] as Layout[])).flatMap((l) =>
							{
								return l.sectionLayouts;
							}).flatMap((sl) => sl.dataset).flatMap((dts) => dts.datas ?? ([] as Data[]))
						)
					);

					const ds = dtArray.filter((d) => d.sortOrder).sort((a, b) => a.sortOrder! - b.sortOrder!) ?? [];
					this.sortedColumns = new Map(
						ds.map((d) => [d.columnName, {order: d.sortOrder!, type: d.sortCriteria ?? "desc"}])
					);
					this.tableController.sortedColumns = this.sortedColumns;
				}

				if (!!layoutsString)
				{
					let layouts = JSON.parse(layoutsString);
					layouts[pageId] = {
						instance: res?.layouts[0],
						instant: new Date()
					};
					localStorage.setItem("layout", JSON.stringify(layouts));
				}
				else
				{
					let layouts = {};
					layouts[pageId] = {
						instance: res?.layouts[0],
						instant: new Date()
					};
					localStorage.setItem("layout", JSON.stringify(layouts));
				}

			})
		).pipe(takeUntil(this._interactionCycle)).subscribe((res) =>
		{
			// this.spinner.hide();
			this.isLoading = false;
			this.refreshData(this.tableController.sortedColumns, newFilter);
		});
	}

	replaceFilterValues(valuesFrom: string)
	{
		let researchString = cloneDeep(valuesFrom);
		const replaceArray =
				  valuesFrom.match(/_@[^\ ]*@_/gm)?.map((substr) =>
				  {
					  return {
						  toReplace: substr,
						  raplaceWith: ""
					  };
				  }) ?? [];

		for (let i = 0; i < replaceArray.length; i++)
		{
			researchString = researchString.replace(
				replaceArray[i].toReplace,
				"'" + replaceArray[i]?.raplaceWith?.replace(/\//gm, "-") + "'"
			);
		}

		return researchString;
	}

	/**
	 * Calculates the size of each column based on the content of the cells and the column label and options, this is necessary to set the width of the columns in the table, and avoid too wide or too narrow columns
	 */
	calculateWidthOfColumnsByContent(): Record<string, number>
	{
		if (!this.layout) return {};

		const HEADER_FONT = "700 14px ElectroluxSans";
		const ROW_FONT = "400 14px ElectroluxSans";
		const MAX_WIDTH = 180;

		let section = this.layout.sectionLayouts.find((sectionLayout) => sectionLayout.id == "LYO_SECTABLE");
		if(!section){
			section = section = this.layout.sectionLayouts.find((sectionLayout) => sectionLayout.id == "LYO_DETAIL_SECTABLE"); //Fix for monitor detail
		}
		const columns: Data[] = section?.dataset[0]?.datas ?? [];
		const columnWeights: Record<string, number> = {};

		// Build column metadata keyed by columnName and initialize weights with header widths
		const columnDetails = new Map<string, ColumnDetail>();
		for (const col of columns)
		{
			const headerWidth = Math.min(
				getTextWidth(this.translateService.instant(col.columnLabel), HEADER_FONT),
				MAX_WIDTH
			);
			columnDetails.set(col.columnName, {width: headerWidth, optionValues: col.optionValues});
			columnWeights[col.columnName] = Math.max(columnWeights[col.columnName] ?? 0, headerWidth);
		}

		// Measure cell content widths and keep the max per column
		for (const row of this.tableController.dataSet)
		{
			for (const key of Object.keys(row))
			{
				const detail = columnDetails.get(key);
				let cellWidth: number;

				if ((detail?.optionValues?.length ?? 0) > 0)
				{
					const displayText = transformIdToValueFromList(detail, row[key], row[key]);
					cellWidth = Math.min(getTextWidth(displayText ?? "", ROW_FONT), MAX_WIDTH);
				}
				else
				{
					cellWidth = Math.min(getTextWidth("" + (row[key] ?? ""), ROW_FONT), MAX_WIDTH);
				}

				columnWeights[key] = Math.max(columnWeights[key] ?? 0, cellWidth);
			}
		}

		return columnWeights;
	}

	resetSort()
	{
		const dtArray: Data[] = Array.from(
			new Set(this.layout?.sectionLayouts?.flatMap((sl) => sl.dataset).flatMap((dts) => dts.datas ?? ([] as Data[])))
		);

		const ds = dtArray.filter((d) => d.sortOrder).sort((a, b) => a.sortOrder! - b.sortOrder!) ?? [];
		this.sortedColumns = new Map(
			ds.map((d) => [d.columnName, {order: d.sortOrder!, type: d.sortCriteria ?? "desc"}])
		);
		this.tableController.sortedColumns = this.sortedColumns;

		sessionStorage.setItem("sort_" + this.pageId, JSON.stringify(this.sortedColumns, replacer));
		this.onSearch(0, this.tableController.dataSet.length, this.sortedColumns, this.savedFilter, this.dts, true);
	}

	/**
	 * Calculates the size of each column based on the content of the cells and the column label, then sets the column weight in the table controller and calculates the column width
	 * @private
	 */
	private calculateSizeComplete()
	{
		this.tableController.columnWeight = this.calculateWidthOfColumnsByContent();
		// Defer to next tick so Angular renders the <data-table> (behind *ngIf="!isLoading")
		// and its ngAfterViewInit sets up calculateColumnWidth with the actual ViewChild refs
		setTimeout(() => this.tableController.calculateColumnWidth(), 0);
	}


	dateRowAnalyze(dateRow: string[], committedRow: any[]): boolean
	{
		// Check if there are dates to validate
		if (dateRow.length === 0)
		{
			return true
		}

		// Check if all dates in committedRow are valid
		return dateRow.every(key =>
		{
			const dateValue = committedRow[key];

			// Check if the date exists and is valid
			return dateValue !== undefined && this.isValidDate(dateValue);
		})
	}

	isValidDate(dateString: string): boolean
	{
		// Consider an empty string as valid
		if (dateString === "")
		{
			return true;
		}
		else
			if (dateString === null)
				return true;

		// RegEx to validate the format
		// DD/MM/YYYY or DD/MM/YYYY hh:mm:ss
		const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}(?:\s([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9])?$/;

		return regex.test(dateString);
	}

	private saveAll(id: string)
	{
		const filter_row = this.tableController.dataSet.filter((row) => row.edited);
		const dateRow = this.layout?.sectionLayouts?.[2]?.dataset?.[0]?.datas?.filter(data => data.type === 'DTY_DATE')?.map(data => data.columnName) || [];
		const rowNumber = cloneDeep(this.tableController.rowNumber);

		let valid = true;
		let index = 0;

		while (valid && index < filter_row.length)
		{

			valid = this.dateRowAnalyze(dateRow, filter_row[index])
			index++;
		}

		if (filter_row.length === 0)
		{

			this.alertService.add({
				type: ALERT_TYPE.WARNING,
				message: "No data change",
				timeout: 5000,
				selfClose: null
			});
		}

		filter_row.forEach(cmtedRow =>
		{

			if (!this.dateRowAnalyze(dateRow, cmtedRow))
			{
				this.alertService.add({
					type: ALERT_TYPE.WARNING,
					message: "Invalid Date",
					timeout: 5000,
					selfClose: null
				});
			}
			else
			{
				//this.spinner.showWithTitle('data', this.translateService.instant('LOADING_SAVE'))
				delete cmtedRow.editing;
				delete cmtedRow.checked;

				this.generalDataService.postData(
					this.apiParent + "/" + this.apiUrl,
					cloneDeep([cmtedRow]),
					new HttpParams().set('new', (cmtedRow.newRow ?? false)).set("id", this.id)
				).pipe(takeUntil(this._interactionCycle)).subscribe({
					next: (res) =>
					{
						//this.spinner.hide();
						this.tableController.deletedRows = [];

						if (res.iResponseCode != 200)
						{
							this.alertService.add({
								type: ALERT_TYPE.DANGER,
								message: "" + res.iResponseCode + " - " + this.translateService.instant(res.sResponseMessage), //res.iResponseCode + ' - ' + res.sResponseMessage,
								timeout: 5000,
								selfClose: null
							});
							//this.tableController.dataSet[rowNumber] = cmtedRow.backup;
							this.tableController.dataSet = cloneDeep(this.tableController.dataSet);
						}
						else
						{
							this.alertService.add({
								type: ALERT_TYPE.SUCCESS,
								message: "" + res.iResponseCode + " - " + res.sResponseMessage, //res.iResponseCode + ' - ' + res.sResponseMessage,
								timeout: 3000,
								selfClose: null
							});

							//this.refreshData();

							this.onSearch(0, this.savedPaginator.loader, this.sortedColumns, this.savedFilter, this.dts, true);

							this.tableController.dataSet[rowNumber] = res.oContent;

							this.tableController.dataSet = cloneDeep(this.tableController.dataSet);

							// Reload main grid after successful save
							this.mainGridReloadData?.();
						}

						this.tableController.rowNumber = -1;

						//this.onCancelClick();
					},
					error: (err) =>
					{
						//this.spinner.hide();
						this.tableController.deletedRows = [];
						this.tableController.rowNumber = -1;
						this.alertService.add({
							type: ALERT_TYPE.WARNING,
							message: err.error.data.iResponseCode + " - " + err.error.data.sResponseMessage,
							timeout: 5000,
							selfClose: null
						});

						//this.onCancelClick();
					}
				});
			}
		});
	}

	private saveRow(id:string): void
	{
		// debugger
		const rowNumber = cloneDeep(this.tableController.rowNumber);
		this.tableController.rowNumber = -1;

		const committedRow = cloneDeep(this.tableController.dataSet[rowNumber]);

		// filter data modified by user for retriveing all DTY_DATE types and check if they are correct date (DD/MM/YYYY)
		let dateRow = this.layout?.sectionLayouts?.[2]?.dataset?.[0]?.datas?.filter(data => data.type === 'DTY_DATE')?.map(data => data.columnName) || [];

		let validDate = this.dateRowAnalyze(dateRow, committedRow);

		if (!committedRow.edited)
		{
			this.alertService.add({
				type: ALERT_TYPE.WARNING,
				message: "No data change",
				timeout: 5000,
				selfClose: null
			});
		}
		else
			if (!validDate)
			{
				this.alertService.add({
					type: ALERT_TYPE.WARNING,
					message: "Invalid Date",
					timeout: 5000,
					selfClose: null
				});
			}
			else
			{
				const filter_row = this.tableController.dataSet.filter((row) => row.edited);

				if (filter_row.length == 1)
				{
					//this.spinner.showWithTitle('data', this.translateService.instant('LOADING_SAVE'))
					delete committedRow.editing;
					delete committedRow.checked;

					this.generalDataService.postData(
						this.apiParent + "/" + this.apiUrl,
						cloneDeep([committedRow]),
						new HttpParams().set('new', (committedRow.newRow ?? false)).set("id", this.id)
					).pipe(takeUntil(this._interactionCycle)).subscribe({
						next: (res) =>
						{

							//this.spinner.hide();
							this.tableController.deletedRows = [];
							// this.refreshData(new Map(), new Array<string>());

							if (res.iResponseCode != 200)
							{
								// debugger

								this.alertService.add({
									type: ALERT_TYPE.DANGER,
									message: "" + res.iResponseCode + " - " + this.translateService.instant(res.sResponseMessage), //res.iResponseCode + ' - ' + res.sResponseMessage,
									timeout: 5000,
									selfClose: null
								});

								this.tableController.dataSet[rowNumber].editing = true
								this.tableController.dataSet = cloneDeep(this.tableController.dataSet);
							}
							else
							{
								//this.refreshData();
								// debugger
								this.alertService.add({
									type: ALERT_TYPE.SUCCESS,
									message: "" + res.iResponseCode + " - " + res.sResponseMessage, //res.iResponseCode + ' - ' + res.sResponseMessage,
									timeout: 3000,
									selfClose: null
								});

								this.onSearch(0, this.savedPaginator.loader, this.sortedColumns, this.savedFilter, this.dts, true);

								this.tableController.dataSet[rowNumber] = res.oContent;

								this.tableController.dataSet = cloneDeep(this.tableController.dataSet);

								// Reload main grid after successful save
								this.mainGridReloadData?.();
							}

							this.tableController.rowNumber = -1;

							//this.onCancelClick();
						},
						error: (err) =>
						{
							//this.spinner.hide();
							this.tableController.deletedRows = [];
							this.tableController.rowNumber = -1;
							this.alertService.add({
								type: ALERT_TYPE.WARNING,
								message: err.error.data.iResponseCode + " - " + err.error.data.sResponseMessage,
								timeout: 5000,
								selfClose: null
							});

							//this.onCancelClick();
						}
					});
				}
				else
				{
					const dialogRef = this.dialog.open(SaveConfirmComponent, {
						data: {
							title: this.translateService.instant("LABEL_SAVE_ALL"),
							content: this.translateService.instant("LABEL_MANY_PENDING_CHANGES"),
							cancelButtonLabel: this.translateService.instant("ACT_NO"),
							cancelButtonColor: "basic",
							allButtonLabel: this.translateService.instant("Save all"),
							allButtonColor: "accent",
							confirmButtonLabel: this.translateService.instant("ACT_YES"),
							confirmButtonColor: "accent"
						}
					});

					dialogRef.afterClosed().subscribe((res) =>
					{
						if (res == 'one')
						{
							//this.spinner.showWithTitle('data', this.translateService.instant('LOADING_SAVE'))
							delete committedRow.editing;
							delete committedRow.checked;

							this.generalDataService.postData(
								this.apiParent + "/" + this.apiUrl,
								cloneDeep([committedRow]),
								new HttpParams().set('new', (committedRow.newRow ?? false))
							).pipe(takeUntil(this._interactionCycle)).subscribe({
								next: (res) =>
								{
									//this.spinner.hide();
									this.tableController.deletedRows = [];
									// this.refreshData(new Map(), new Array<string>());

									if (res.iResponseCode != 200)
									{

										this.alertService.add({
											type: ALERT_TYPE.DANGER,
											message: "" + res.iResponseCode + " - " + this.translateService.instant(res.sResponseMessage), //res.iResponseCode + ' - ' + res.sResponseMessage,
											timeout: 5000,
											selfClose: null
										});
										this.tableController.dataSet[rowNumber].editing = true
										this.tableController.dataSet = cloneDeep(this.tableController.dataSet);
									}
									else
									{
										//this.refreshData();

										this.alertService.add({
											type: ALERT_TYPE.SUCCESS,
											message: "" + res.iResponseCode + " - " + res.sResponseMessage, //res.iResponseCode + ' - ' + res.sResponseMessage,
											timeout: 3000,
											selfClose: null
										});

										this.tableController.dataSet[rowNumber] = res.oContent;

										this.tableController.dataSet = cloneDeep(this.tableController.dataSet);

										// Reload main grid after successful save
										this.mainGridReloadData?.();
									}

									this.tableController.rowNumber = -1;

									//this.onCancelClick();
								},
								error: (err) =>
								{
									//this.spinner.hide();
									this.tableController.deletedRows = [];
									this.tableController.rowNumber = -1;
									this.alertService.add({
										type: ALERT_TYPE.WARNING,
										message: err.error.data.iResponseCode + " - " + err.error.data.sResponseMessage,
										timeout: 5000,
										selfClose: null
									});

									//this.onCancelClick();
								}
							});
						}
						else
							if (res == 'all')
							{
								this.saveAll(this.id);
							}
					});
				}
			}
	}

	private deleteRow(): void
	{
		const dialogRef = this.dialog.open(DialogComponent, {
			data: {
				title: this.translateService.instant("LABEL_DELETE_TITLE"),
				content: this.translateService.instant("LABEL_CONFIRM"),
				cancelButtonLabel: this.translateService.instant("ACT_NO"),
				cancelButtonColor: "basic",
				confirmButtonLabel: this.translateService.instant("ACT_YES"),
				confirmButtonColor: "warn"
			}
		});

		dialogRef.afterClosed().subscribe((res) =>
		{
			if (res)
			{
				//this.spinner.showWithTitle('data', this.translateService.instant('LOADING_DELETE'));

				this.generalDataService.deleteData(this.apiParent + "/" + this.apiUrl, [this.tableController.dataSet[this.tableController.rowNumber]], "d").pipe(takeUntil(this._interactionCycle)).subscribe({
					next: (res) =>
					{

						this.tableController.dataSet.splice(this.tableController.rowNumber, 1);

						this.tableController.dataSet = cloneDeep(this.tableController.dataSet);
						this.tableController.deletedRows = [];
						this.tableController.rowNumber = -1;
						//this.spinner.hide();
						this.alertService.add({
							type: ALERT_TYPE.SUCCESS,
							message: res.iResponseCode + " - " + res.sResponseMessage,
							timeout: 3000,
							selfClose: null
						});

						this.onCancelClick();
					},
					error: (err) =>
					{
						this.tableController.deletedRows = [];
						this.tableController.rowNumber = -1;
						this.tableController.dataSet = cloneDeep(this.tableController.dataSet);
						//this.spinner.hide();
						this.alertService.add({
							type: ALERT_TYPE.WARNING,
							message: err.error.data.iResponseCode + " - " + err.error.data.sResponseMessage,
							timeout: 5000,
							selfClose: null
						});
						//this.onCancelClick();
					}
				});
			}
			else
			{
				this.tableController.deletedRows = [];
			}
		});
	}


	private exportAll(): void
	{
		if (this.tableController.numElementsSize > 5000)
		{
			const dialogRef = this.dialog.open(DialogComponent, {
				data: {
					title: this.translateService.instant("LABEL_LARGE_AMOUNT_DATA"),
					content: this.translateService.instant("LABEL_LARGE_AMOUNT_DATA_CONFIRM"),
					cancelButtonLabel: this.translateService.instant("ACT_NO"),
					cancelButtonColor: "basic",
					confirmButtonLabel: this.translateService.instant("ACT_YES"),
					confirmButtonColor: "warn"
				}
			});

			dialogRef.afterClosed().subscribe((res) =>
			{
				if (res)
				{
					//this.spinner.showWithTitle('data', this.translateService.instant('LOADING_EXPORT') + ' ' + this.titlePage);

					this.generalDataService.exportDataExcel(
						this.apiParent + "/" + this.apiUrl,
						"excel",
						this.savedParams.set(
							"dataset",
							this.layout!["sectionLayouts"].filter((sectionLayout) => sectionLayout.id == "LYO_SECTABLE").pop()?.dataset[0].id ?? ""
						),
						[]
					).pipe(takeUntil(this._interactionCycle)).subscribe((blob) =>
					{
						saveAs(blob, `${this.titlePage}.xlsx`);
						//this.spinner.hide();
					});
				}
			});
		}
		else
		{
			//this.spinner.showWithTitle('data', this.translateService.instant('LOADING_EXPORT') + ' ' + this.titlePage);

			this.generalDataService.exportDataExcel(
				//this.apiParent + "/" + this.apiUrl,
				(!!this.apiUrl ? this.apiParent + "/" + this.apiUrl : this.apiParent),
				"excel",
				this.savedParams.set(
					"dataset",
					this.layout!["sectionLayouts"].filter((sectionLayout) => sectionLayout.id == "LYO_SECTABLE").pop()?.dataset[0].id ?? ""
				),
				[]
			).pipe(takeUntil(this._interactionCycle)).subscribe((blob) =>
			{
				saveAs(blob, `${this.titlePage}.xlsx`);
				//this.spinner.hide();
			});
		}
	}

	private importAll(): void
	{
		const dialogEvent = this.dialog.open(DndComponent, {
			data: {
				title: "UPLOADING",
				code: "Upload file: ",
				message: "Are you sure you want to upload this file?",
				btn: "Upload",
				type: "any",
				cancelBtn: "Close"
			}
		});

		dialogEvent.afterClosed().subscribe(async (dndResponse) =>
		{
			if (!!dndResponse && dndResponse.send)
			{
				const uploadFiles: File[] = dndResponse.files;

				for (let file of uploadFiles)
				{

					//this.spinner.showWithTitle('data', this.translateService.instant('LOADING_IMPORT') + ' ' + this.titlePage);
					await firstValueFrom(
						this.generalDataService.importExcel(
							this.apiParent + "/" + this.apiUrl + "/import",
							file
						)
					).then((res) =>
					{
						if (res.type === 'application/json')
						{
							//The response is Blob
							res.text().then(stringResponse =>
							{
								let response = JSON.parse(stringResponse);
								if (response.data.iResponseCode !== 200)
								{
									this.alertService.add({
										type: ALERT_TYPE.WARNING,
										message: response.data.oContent,
										timeout: 10000,
										selfClose: null
									});
								}
								else
								{
									this.alertService.add({
										type: ALERT_TYPE.SUCCESS,
										message: "File Uploaded",
										timeout: 5000,
										selfClose: null
									});
								}
							})
						}
						else
						{
							if (res.size != 0)
							{
								saveAs(res, `${this.titlePage}_RESULT.xlsx`);
							}

							this.alertService.add({
								type: ALERT_TYPE.DANGER,
								message: "File Uploaded with Errors",
								timeout: 5000,
								selfClose: null
							});
						}

						this.onSearch(0, this.savedPaginator.loader, this.sortedColumns, this.savedFilter, this.dts, true);
					}).catch((err) =>
					{
						this.alertService.add({
							type: ALERT_TYPE.WARNING,
							message: "Something went wrong, please try again or contact webmaster",
							timeout: 5000,
							selfClose: null
						});
					}).finally(() =>
					{
						//this.spinner.hide();
					});
				}
			}
		});
	}

	private deleteMultipleRow(): void
	{
		const dialogRef = this.dialog.open(DialogComponent, {
			// width: '250px',
			data: {
				title: this.translateService.instant("LABEL_DELETE_TITLE"),
				content: this.translateService.instant("LABEL_DELETE_CONFIRM"),
				//content: `Are you sure you want map Original Final Destination [ ${data.oldRecord.finalDestination} ] Destination CID ["${data.oldRecord.destinationCid}"] to "${data.record.rdcName}"?`,
				cancelButtonLabel: this.translateService.instant("ACT_NO"),
				cancelButtonColor: "basic",
				confirmButtonLabel: this.translateService.instant("ACT_YES"),
				confirmButtonColor: "warn"
			}
		});

		dialogRef.afterClosed().subscribe((res) =>
		{
			if (!!res)
			{
				if (this.tableController.selection.selected.length > 0)
				{
					const myselection: any[] = this.tableController.selection.selected;

					//this.spinner.showWithTitle('data', this.translateService.instant('LOADING_DELETE'));
					forkJoin(myselection.map((value, i, _) =>
					{
						return this.generalDataService.deleteData(this.apiParent + "/" + this.apiUrl, [myselection[i]], "d")
					})).pipe(
						takeUntil(this._interactionCycle)
					).subscribe({
						next: (res) =>
						{

							res.forEach((value, i) =>
							{
								this.alertService.add({
									type: value.iResponseCode < 300 ? ALERT_TYPE.SUCCESS : ALERT_TYPE.DANGER,
									message: value.iResponseCode + " - " + value.sResponseMessage,
									timeout: 3000,
									selfClose: null
								});
							})

							if (!res.some(r => r.iResponseCode >= 300))
							{
								this.tableController.selection.clear();
								this.tableController.deletedRows = [];
								this.tableController.rowNumber = -1;
							}

							this.onCancelClick();
						},
						error: (err) =>
						{
							this.tableController.selection.clear();
							this.tableController.deletedRows = [];
							this.tableController.rowNumber = -1;
							//this.spinner.hide();
							this.alertService.add({
								type: ALERT_TYPE.WARNING,
								message: err.error.data.iResponseCode + " - " + err.error.data.sResponseMessage,
								timeout: 5000,
								selfClose: null
							});

							//this.onCancelClick();
						}
					});
				}
			}
		});
	}


	private exportSelected(): void
	{
		if (!!this.layout)
			this.savedParams = this.savedParams.append(
				"dataset",
				this.layout["sectionLayouts"].filter((sectionLayout) => sectionLayout.id == "LYO_SECTABLE").pop()?.dataset[0].id ?? ""
			);

		//this.spinner.showWithTitle('data', this.translateService.instant('LOADING_EXPORT') + ' ' + this.titlePage);
		this.generalDataService.exportDataExcel(
			(!!this.apiUrl ? this.apiParent + "/" + this.apiUrl : this.apiParent),
			"excel",
			this.savedParams.set(
				"dataset",
				this.layout!["sectionLayouts"].filter((sectionLayout) => sectionLayout.id == "LYO_SECTABLE").pop()?.dataset[0].id ?? ""
			),
			this.tableController.selection.selected
		).pipe(takeUntil(this._interactionCycle)).subscribe((blob) =>
		{
			saveAs(blob, `${this.titlePage}.xlsx`);
			////this.spinner.hide();
		});
	}

	/**
	 * Reloads the grid applying current settings.
	 *
	 * Starts a new search from the first page with:
	 * - this.savedPaginator.loader: row limit to load.
	 * - this.sortedColumns: current sort settings.
	 * - this.savedFilter: persisted filters.
	 * - this.dts: dataset identifier.
	 * - refreshForcing = true: forces refresh avoiding stale data.
	 */
	reloadData = (extraParameters: Map<string, string | number | boolean> = new Map()): void =>
	{


		this.onSearch(0, this.savedPaginator.loader, this.sortedColumns, this.savedFilter, this.dts, true, extraParameters);
	}

}

interface ColumnDetail
{
	width: number;
	optionValues: any[];
}
